// extracted by mini-css-extract-plugin
module.exports = {"root":"InquiryWizardPanelHeading_root__ycPlA","title":"InquiryWizardPanelHeading_title__32uzc","subtitle":"InquiryWizardPanelHeading_subtitle__5IJwH"};